/* Stylesheet */

.searchbar {
  top: 0;
  bottom: 0;
  right: 48px;
  width: 50%;
  position: absolute;
  z-index: 200;
  --box-shadow: var(--ion-box-shadow);
  --border-radius: 48px;
  --color: var(--ion-color-text-primary);
  --icon-color: var(--ion-color-text-tertiary);
  --placeholder-color: var(--ion-color-text-tertiary);
}
